module.exports = __webpack_public_path__ + "static/circle-3-8723217dbb3101ed1458fff6b1540bec.jpg";